/********************************************
* Video banner
********************************************/
function fnVideoBanner( i, oSection ) {

	/*****************
	* Objects
	*****************/
	var oSection					= $( oSection ),
		oVideo						= $( 'video', oSection ),
		oPlayButton					= $( '.button', oSection );


	/*************************
	* Hover play button
	*************************/
	oPlayButton.hover( function() {
		$( this ).closest( oSection ).toggleClass( 'hover' );
	});


	/*************************
	* Pause video
	*************************/
	oVideo.each( function() {

		$( this ).get( 0 ).pause();

	});


	/*************************
	* Play video button
	*************************/
	oPlayButton.on( 'click', function() {

		// Apply class to section
		$( this ).closest( oSection ).addClass( 'video-active' );

		// Play video
		oVideo.get( 0 ).play();

	});


	/*************************
	* Return to content
	*************************/
	oVideo.on( 'click', function() {

		// End video
		$( this ).get( 0 ).pause();

		// Remove class from section
		$( this ).closest( oSection ).removeClass( 'video-active' );

	});

}


// END OF DOCUMENT
